"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var DownloadStepContracts_1 = require("./DownloadStepContracts");
var DropdownFormControl_1 = __importDefault(require("../formControls/DropdownFormControl"));
var DropdownStep = function (_a) {
    var id = _a.id, label = _a.label, stepNumber = _a.stepNumber, isEnabled = _a.isEnabled, options = _a.options, selectedValue = _a.selectedValue, prevStatus = _a.prevStatus, nextStatus = _a.nextStatus, handleChange = _a.handleChange;
    var handleDropdownChange = function (event) {
        event.preventDefault();
        handleChange(event);
    };
    return (react_1.default.createElement("div", { className: "spr-dropdown-step" },
        react_1.default.createElement("div", { className: "row" },
            react_1.default.createElement("div", { className: "col-1" },
                react_1.default.createElement("div", { className: "spr-dropdown-step__step-info" },
                    react_1.default.createElement("div", { className: "spr-dropdown-step__indicator-wrapper" },
                        react_1.default.createElement("div", { className: "spr-dropdown-step__indicator ".concat(isEnabled ? "enabled" : "") }, stepNumber)),
                    react_1.default.createElement("div", { className: "spr-dropdown-step__process-wrapper" },
                        react_1.default.createElement("div", { className: "spr-dropdown-step__process spr-dropdown-step__process--prev ".concat(DownloadStepContracts_1.DropdownStepProcessStatus[prevStatus]) }),
                        react_1.default.createElement("div", { className: "spr-dropdown-step__process spr-dropdown-step__process--next ".concat(DownloadStepContracts_1.DropdownStepProcessStatus[nextStatus]) })))),
            react_1.default.createElement("div", { className: "col-7" },
                react_1.default.createElement("div", { className: "spr-dropdown-step__dropdown-wrapper" },
                    react_1.default.createElement(DropdownFormControl_1.default, { id: id, label: label, isEnabled: isEnabled, options: options, selectedValue: selectedValue, handleChange: handleDropdownChange }))),
            react_1.default.createElement("div", { className: "col-4" }))));
};
DropdownStep.displayName = "Dropdown Step";
exports.default = DropdownStep;
